export default __webpack_public_path__ + "static/media/IBMPlexSans-SemiBoldItalic.0a41bd8b.woff";